import { useEffect, useState } from "react"
import VisitListItem from "./VisitListItem"

const VisitList = props => {
  const [visits, setVisits] = useState(props.visits || [])

  useEffect(() => {
    setVisits(props.visits || [])
  }, [props.visits])

  return (
    <div>
      {visits && visits.length > 0 ? (
        <div className="visits-adaptive-grid">
          {visits.map((item: any, index: number) => (
            <div key={item?.id || index} className="visit-card-wrapper">
              <VisitListItem model={item} />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default VisitList
